module.exports = __webpack_public_path__ + "img/title.71f9ac14.png";